export default __webpack_public_path__ + "static/media/comm 5.2224efab.jpg";